import ListItemWithIcon from 'components/content/ListItemWithIcon';
import { useMemo } from 'react';

import SidebarSectionNoData from '../SidebarSectionNoData';
import SidebarSectionSkeleton from '../SidebarSectionSkeleton';
import styles from '../styles/SidebarSection.module.scss';

interface SystemFleetsSidebarSectionProps {
    icon: 'user' | 'vehicle';
    header: string;
    items?: any[];
    isLoading?: boolean;
}

const SystemFleetsSidebarSection = ({ icon, header, items, isLoading }: SystemFleetsSidebarSectionProps) => {
    const itemIcon = useMemo(() => {
        switch (icon) {
            case 'user':
                return 'rioglyph rioglyph-user';
            case 'vehicle':
                return 'rioglyph rioglyph-van-baseline';
            default:
                return;
        }
    }, [icon]);

    if (isLoading) {
        return <SidebarSectionSkeleton header={header} />;
    }

    if (!items?.length) {
        return <SidebarSectionNoData header={header} />;
    }

    return (
        <div className={styles.SidebarSection}>
            <p data-testid='system-fleet-sidebar-section-header' className={styles.SidebarSection__title}>
                {header}
            </p>
            <ul data-testid='system-fleet-sidebar-section-items-list' className={styles.SidebarSection__list}>
                {items.map(_ => (
                    <li
                        key={icon + _}
                        data-testid='system-fleet-sidebar-section-item'
                        className={styles.SidebarSection__item}
                    >
                        <ListItemWithIcon icon={itemIcon} label={_} />
                    </li>
                ))}
            </ul>
            <div data-testid='system-fleet-sidebar-section-footer' className={styles.SidebarSection__footer}>
                <p className={styles.SidebarSection__footerText}>Total</p>
                {items.length}
            </div>
        </div>
    );
};

export default SystemFleetsSidebarSection;
